export default {

    anchorName: 'yourUniqueName',
    url: 'https://appjustable.com'

}


// WEBPACK FOOTER //
// ./src/store/elementSettings/anchorsettings.js